import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { ErrorBoundary } from './features/common/ErrorBoundary.jsx'

// Interceptor global para adjuntar token SuperAdmin y credenciales en peticiones /api/
if (typeof window !== 'undefined') {
  const originalFetch = window.fetch;
  window.fetch = async function (input, init = {}) {
    let url = typeof input === 'string' ? input : input instanceof Request ? input.url : '';
    if (url.startsWith('/api') || url.includes('/api/')) {
      const token = localStorage.getItem('softmatek_admin_token') ||
                    localStorage.getItem('softmatek_token') ||
                    localStorage.getItem('mapau_admin_token');
      const headers = new Headers(init.headers || (input instanceof Request ? input.headers : {}));
      if (token && !headers.has('Authorization')) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      init = {
        ...init,
        headers,
        credentials: init.credentials || 'include'
      };
    }
    return originalFetch.call(this, input, init);
  };
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
